import moment from 'moment'
import React, {FC, useState} from 'react'
import {ProgressBar} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useNavigate} from 'react-router-dom'
import {DeleteConfirmation} from '../modal/DeleteConfirmation'
import {useHomeQueryResponse} from '../../../pages/home/provider/HomeResponseProvider'
import {delProjectData} from '../../../modules/apps/project/core/_requests'
import {toast} from 'react-toastify'
import {useAuth} from '../../../modules/auth'
import './table.scss'
import clsx from "clsx";
import {useThemeMode} from "../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider";

type TColProps = {
  data: {
    colIndex: number
    value: any
    type: 'text' | 'date' | 'integer' | 'decimal' | 'percent' | 'action' | 'financial'
    rowIndex: number
    dataKey: string
    rowGuid: string
    content?: any
    pathPrefix?: string
  }
  rowType: 'data' | 'header'
  onSort?: (crit: {Sort: string; Order: 'asc' | 'desc'}) => void
  activeSort?: {Sort: string; Order: 'asc' | 'desc'}
}

const TCol: FC<TColProps> = ({data, rowType = 'data', onSort, activeSort}) => {
  // console.log('rowType : ', rowType)
  const navigate = useNavigate()
  const {refetch} = useHomeQueryResponse()
  const intl = useIntl()
  const {setAuthMessage, logout, currentUser, } = useAuth()
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false)
  const onCancel = () => {
    setOpenDeleteModal(false)
  }
  const onDelete = async () => {
    const response = await delProjectData(
      data?.rowGuid,
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
          //refetch()
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    if (response?.data && response?.data?.Status?.Success) {
      refetch()
    }
  }

  const text: string = 'Êtes-vous certain(e) de vouloir supprimer'
  const {mode} = useThemeMode()

  if (rowType === 'header') {
    return (
      <th
        className={
          'text-gray-400 fw-bolder ' +
          (data.dataKey && data.dataKey !== '' ? 'cursor-pointer ' : '')
        }
        style={{borderBottom: '1px dotted #A0A0A0'}}
        onClick={() => {
          if (onSort && data.dataKey && data.dataKey !== '') {
            const newSortCrit = {
              Sort: data.dataKey,
              Order: (activeSort?.Sort === data.dataKey
                ? activeSort.Order === 'asc'
                  ? 'desc'
                  : 'asc'
                : 'asc') as 'asc' | 'desc',
            }
            onSort(newSortCrit)
          }
        }}
      >
        <div
          className='d-flex fw-bolder fs-5 align-items-center'
          style={{flexWrap: 'nowrap', whiteSpace: 'nowrap'}}
        >
          <span className='text-gray-400'>{intl.formatMessage({id: data.value})}</span>
          {activeSort?.Sort === data.dataKey && activeSort.Order === 'asc' && (
            <i className='fa fa-caret-down text-danger mx-3'></i>
          )}
          {activeSort?.Sort === data.dataKey && activeSort.Order === 'desc' && (
            <i className='fa fa-caret-up text-danger mx-3'></i>
          )}
        </div>
      </th>
    )
  }
  return (
    <td style={{borderBottom: '1px dotted #A0A0A0', textAlign: (data?.type === 'financial' ? 'right' : 'left')}}>
      <div>
        {data?.type !== 'financial' ? data.value : ''} {data.type === 'percent' ? ' %' : ''}
        {/* {createContentCol(data)} */}
        <CreateContentCol data={data} />
        {data?.type === 'financial' && (
          <div className='' style={{textAlign: 'right'}}>
            {intl.formatNumber(data.value || 0, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            })}
          </div>
        )}
        {data?.type === 'action' && (
          <div className='d-flex align-items-center'>
            <div
              className='cursor-pointer p-3'
              onClick={() => {
                // pathPrefix
                navigate((data.pathPrefix || '/new-project/tab1') + '/' + data.rowGuid)
              }}
            >
              <i className='fa fa-edit fs-3x'></i>
            </div>
            {currentUser?.Profile === 'Administrateur' && (
            <div
              className='cursor-pointer p-3'
              onClick={() => {
                setOpenDeleteModal(true)
              }}
            >
              <i className='fa-solid fa-xmark fs-3x'></i>
            </div>
            )} 
          </div>
        )}
      </div>
      {data.type === 'percent' && (
        <div className={clsx('py-2',{'dark': mode === 'dark'})}>
          <ProgressBar  variant={'primary'} now={data.value} style={{height: 10}} />
        </div>
      )}
      <DeleteConfirmation
        show={openDeleteModal}
        onDelete={onDelete}
        onCancel={onCancel}
        text={text}
      />
    </td>
  )
}

const CreateContentCol: FC<any> = ({data}) => {
  const navigate = useNavigate()
  if (data?.content) {
    return (
      <div
        onClick={() => {
          if (data.dataKey === 'LastModificationDate' || data.dataKey === 'CompanyName') {
            navigate((data.pathPrefix || '/new-project/tab1') + '/' + data.rowGuid)
          }
        }}
      >
        {Object.keys(data.content).map((keyData, i) => {
          return (
            <div
              className={data.content[keyData]?.className}
              key={JSON.stringify(data.content) + i}
            >
              {data.content[keyData]?.type === 'date'
                ? moment(data.content[keyData]?.value).format('DD/MM/YYYY ') +
                  moment(data.content[keyData]?.value).format('HH') +
                  'h' +
                  moment(data.content[keyData]?.value).format('mm')
                : data.content[keyData]?.value}
            </div>
          )
        })}
      </div>
    )
  }
  return <div></div>
}

export default TCol
